import React from 'react';
import type { OperationsTvHealth } from './types';

const toneClass: Record<OperationsTvHealth['tone'], string> = {
  healthy: 'text-emerald-300',
  warning: 'text-amber-300',
  danger: 'text-rose-300',
};

const OperationsTvFooter: React.FC<{
  health: OperationsTvHealth;
  lastRefresh: string;
  refreshMs: number;
  trackerError: string | null;
}> = ({ health, lastRefresh, refreshMs, trackerError }) => {
  const refreshText = lastRefresh
    ? new Date(lastRefresh).toLocaleTimeString('en-GB', { hour12: false })
    : '—';

  return (
    <footer className="ops-tv-glass-panel relative mt-4 overflow-hidden rounded-2xl border border-amber-300/25 bg-[linear-gradient(95deg,rgba(2,6,23,0.94)_0%,rgba(6,12,28,0.94)_45%,rgba(4,9,20,0.95)_100%)] px-5 py-3 text-[11px] shadow-[0_20px_56px_rgba(2,6,23,0.7)]">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_12%_20%,rgba(245,158,11,0.13),transparent_40%),radial-gradient(circle_at_84%_40%,rgba(16,185,129,0.08),transparent_35%)]" />
      <div className="relative grid grid-cols-1 gap-3 md:grid-cols-4">
      <div className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <p className="font-black uppercase tracking-[0.16em] text-slate-500">Weather</p>
        <p className="mt-1 font-semibold text-slate-200">HTKA monitor feed active</p>
      </div>
      <div className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <p className="font-black uppercase tracking-[0.16em] text-slate-500">Last Refresh</p>
        <p className="mt-1 font-mono text-[13px] font-black text-slate-100">{refreshText}</p>
      </div>
      <div className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <p className="font-black uppercase tracking-[0.16em] text-slate-500">Auto Refresh</p>
        <p className="mt-1 font-semibold text-slate-200">{Math.round(refreshMs / 1000)}s interval</p>
      </div>
      <div className="rounded-xl border border-white/10 bg-white/[0.02] px-3 py-2 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]">
        <p className="font-black uppercase tracking-[0.16em] text-slate-500">Tracker Feed</p>
        <p className={`mt-1 inline-flex items-center gap-2 font-black uppercase tracking-[0.08em] ${trackerError ? 'text-rose-300' : toneClass[health.tone]}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${trackerError ? 'bg-rose-300 shadow-[0_0_10px_rgba(244,63,94,0.8)]' : health.tone === 'healthy' ? 'bg-emerald-300 shadow-[0_0_10px_rgba(16,185,129,0.8)] ops-tv-live-node' : health.tone === 'warning' ? 'bg-amber-300 shadow-[0_0_10px_rgba(245,158,11,0.8)]' : 'bg-rose-300 shadow-[0_0_10px_rgba(244,63,94,0.8)]'}`} />
          {trackerError ? 'Tracking Delay' : health.label}
        </p>
      </div>
      </div>
    </footer>
  );
};

export default React.memo(OperationsTvFooter);
